import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "BrixBot - AI Customer Service", 
  description = "Transform your customer service with AI chatbots trained specifically on your business data.", 
  isIndexable = false 
}) => {
  const robotsContent = isIndexable ? "index, follow" : "noindex, nofollow";
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsContent} />
    </Helmet>
  );
};

export default SEOHead;